// Reducer
import { ACTION_TYPES } from './cms-actions';
import { CmsState, initialState } from './cms-state';

export default (state: CmsState = initialState, action): CmsState => {
  switch (action.type) {
    case ACTION_TYPES.SET_CMS_CONTENT: {
      //    const tmpMap = new Map(state.content.set(action.payload.type, action.payload.content));
      return {
        ...state,
        content: { ...state.content, [action.payload.type]: action.payload.content }
      };
    }

    case ACTION_TYPES.SET_MARKETING: {
      return {
        ...state,
        marketing: action.payload
      };
    }

    case ACTION_TYPES.SET_CMS_CREATED: {
      return {
        ...state,
        appStyleCreated: true
      };
    }

    case ACTION_TYPES.SET_ERROR: {
      return {
        ...state,
        error: action.payload.error
      };
    }
    default:
      return state;
  }
};
